import { Pipe, PipeTransform } from '@angular/core';

import { ProductCategory } from '@iss/wo-common/trade-off';

type OrderLineData = Readonly<{
  productData: Readonly<{
    productCategory: ProductCategory;
  }>
}>;
type OrderLine<T extends OrderLineData> = T;
type OrderLinePipeInput<T extends OrderLineData> = readonly OrderLine<T>[];

export const isTransportOrderLine = (input: OrderLineData) => input.productData.productCategory === 'TRANSPORT';

@Pipe({
  name: 'serviceOrderLine',
  standalone: true,
})
export class ServiceOrderLinePipe implements PipeTransform {
  public transform<T extends OrderLineData>(input: OrderLinePipeInput<T>): OrderLine<T> | undefined {
    return input.find(isTransportOrderLine);
  }
}
